'use strict';

/* Views */
import PiperGuestEdit from './guest/edit/guest-edit.component';
import PiperGuestList from './guest/list/guest.component';
import PiperListEdit from './list/edit/list-edit.component';
import PiperListList from './list/show/list.component';

/* Components */
import GuestInfoComponent from '../../components/piper-guest-info/guest-info.component';

/* Services */
import PiperGuestService from '../../services/piper-guest/piper-guest.service';
import PiperListService from '../../services/piper-list/piper-list.service';

export default angular.module('conduuApp.piper', [PiperGuestEdit, PiperGuestList, PiperListEdit, PiperListList,
  GuestInfoComponent, PiperGuestService, PiperListService])
  .name;



// WEBPACK FOOTER //
// ./client/app/piper/index.js